import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "../../styles/pages-styles/landing-layout-pages-styles/ContactPage.css";


const ContactPage = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

   emailjs
     .sendForm(
       process.env.REACT_APP_EMAILJS_SERVICE_ID,
       process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
       form.current,
       process.env.REACT_APP_EMAILJS_PUBLIC_KEY
     )
     .then(
       (result) => {
         console.log(result.text);
         alert("Message sent successfully!");
       },
       (error) => {
         console.log(error.text);
         alert("Something went wrong.");
       }
     );

    e.target.reset();
  };

  return (
    <form ref={form} onSubmit={sendEmail} className="contact-form">
      <input name="user_name" type="text" placeholder="Your Name" required />
      <input name="user_email" type="email" placeholder="Your Email" required />
      <textarea name="message" placeholder="Your Message" required></textarea>
      <button type="submit">Send</button>
    </form>
  );
};

export default ContactPage;
